module.exports = __webpack_public_path__ + "img/step6-eva.e9612afd.png";